import { render, staticRenderFns } from "./OrderDetailMeta.vue?vue&type=template&id=4bf47352"
import script from "./OrderDetailMeta.vue?vue&type=script&lang=js"
export * from "./OrderDetailMeta.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailMeta.vue?vue&type=style&index=0&id=4bf47352&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports